































































import { Component, Prop, Vue } from "vue-property-decorator";
import { authModule, jimizzModule, surveysModule, toastsModule } from "@/store";
import { Survey } from "@/store/surveys/survey";
import { AuthStatus } from "@/store/auth/auth-status.enum";
import { SurveyChoice } from "@/store/surveys/survey-choice";
import { ToastType } from "@/store/toasts/toast-type.enum";
import { round } from "@/helpers/round.helper";

@Component
export default class HolderSurvey extends Vue {
  @Prop({ default: null }) survey!: Survey;

  loading = false;

  get isFullyAuthenticated(): boolean {
    return authModule.authStatus === AuthStatus.Full;
  }

  get canVote(): boolean {
    return (
      authModule.authStatus === AuthStatus.Full &&
      this.survey.isActive &&
      this.totalBalance > 0
    );
  }

  get hasVoted(): boolean {
    return !!this.survey.userChoice;
  }

  get totalBalance(): number {
    return round(jimizzModule.totalBalance);
  }

  async login() {
    await authModule.login();
  }

  async onSurveyChoiceClick(choice: SurveyChoice) {
    if (!this.hasVoted && this.canVote) {
      try {
        this.loading = true;
        await surveysModule.vote({
          surveyId: this.survey.id,
          choiceId: choice.id,
        });
        toastsModule.addToast({
          type: ToastType.Success,
          text: this.$t("holder-assembly.surveys.success"),
        });
      } catch (e) {
        toastsModule.addToast({
          type: ToastType.Error,
          text: this.$t("holder-assembly.surveys.error"),
        });
      } finally {
        this.loading = false;
      }
    }
  }
}
